import React from 'react';
import { Box, Icon, StatusIndicator } from '@cloudscape-design/components';
import { CopilotMessage, useCopilot } from './CopilotContext';
import { CopilotMarkdown } from './CopilotMarkdown';

interface CopilotMessageBubbleProps {
  message: CopilotMessage;
}

function getUserInitials(userId: string): string {
  if (!userId) return '?';
  // Take first 2 characters of the userId, uppercase
  return userId.slice(0, 2).toUpperCase();
}

export function CopilotMessageBubble({ message }: CopilotMessageBubbleProps) {
  const { userId } = useCopilot();
  const isUser = message.role === 'user';

  return (
    <div
      className={`copilot-message-row ${isUser ? 'copilot-message-row--user' : 'copilot-message-row--agent'}`}
    >
      {!isUser && (
        <div
          className="copilot-message-avatar copilot-message-avatar--agent"
          role="img"
          aria-label="Co-Pilot"
        >
          <Icon name="gen-ai" size="small" />
        </div>
      )}
      <div
        className={`copilot-message-bubble ${
          isUser
            ? 'copilot-message-bubble--user'
            : message.isError
              ? 'copilot-message-bubble--error'
              : 'copilot-message-bubble--agent'
        }`}
      >
        {isUser ? (
          <Box variant="p" color="inherit">
            {message.content}
          </Box>
        ) : message.isError ? (
          <StatusIndicator type="error">{message.content}</StatusIndicator>
        ) : (
          <CopilotMarkdown content={message.content} />
        )}
      </div>
      {isUser && (
        <div
          className="copilot-message-avatar copilot-message-avatar--user"
          role="img"
          aria-label="You"
        >
          {getUserInitials(userId)}
        </div>
      )}
    </div>
  );
}
